/**
 * services/auth/auth.ts
 * The ONLY platform calls SK Upsell makes — both read-only session lifecycle.
 * SK Upsell owns no authentication: login / signup / password / email-verify /
 * token refresh are entirely SK-Platform-FE's. The session cookie is httpOnly
 * and never touched here.
 */
import axiosInstance from '../../api-endpoints/axiosInstance';
import { Token_Handler } from '../../storage/tokenHandler';
import { Platform_Me_Url, Platform_Logout_Url } from '../../api-endpoints/endpoints';

/* ── Identity probe — GET /v1/me (5s cache + in-flight dedupe) ────────────── */
const ME_TTL = 5_000;
let meCache: { data: unknown; at: number } | null = null;
let meInflight: Promise<unknown> | null = null;

export const invalidateMeCache = (): void => {
  meCache = null;
};

export const getCurrentUser = async (): Promise<unknown> => {
  if (meCache && Date.now() - meCache.at < ME_TTL) return meCache.data;
  if (!meInflight) {
    meInflight = axiosInstance
      .get(Platform_Me_Url)
      .then((r) => {
        meCache = { data: r.data, at: Date.now() };
        return r.data;
      })
      .finally(() => {
        meInflight = null;
      });
  }
  return meInflight;
};

/* ── Sign out — POST /v1/auth/logout (ends the platform session) ───────────── */
export const logoutUser = async (): Promise<void> => {
  try {
    await axiosInstance.post(Platform_Logout_Url);
  } finally {
    invalidateMeCache();
    await Token_Handler.clearAll();
  }
};
